import React from 'react';

import { Box, SpeedDial, SpeedDialAction, Stack, Typography, Link } from '@mui/material';

import { Link as RouterLink } from 'react-router-dom';

import { Avatar } from 'components/Avatar';
import { ListCard } from 'components/Card';
import { IconWrapper } from 'components/Icon';
import { useAuth } from 'lib/auth';
import { paths } from 'routes';
import { useGetSupplierFilesCount } from '../api/getSupplierFilesCount';

export const SupplierListItem = ({
  Name: name,
  Status: status,
  VAT: vatNumber,
  markForDelete,
  dps_id,
  dc_id,
  show_files = true,
}) => {
  const { account } = useAuth();
  const {
    //@ts-ignore
    data: { count: filesCount },
  } = useGetSupplierFilesCount(dps_id, dc_id);

  return (
    <ListCard>
      <Box display="flex" alignItems="center" flex={{md: 5, lg: 6}} gap={1.5}>
        <Avatar name={name} />

        <Typography
          variant="body1"
          fontWeight={700}
          fontSize="1rem"
          sx={{ textDecoration: 'underline' }}
        >
          {name}
        </Typography>
      </Box>

      {account.super_admin && (
        <Stack justifyContent="center" flex={1}>
          <Typography variant="caption" fontWeight={700} color="text.secondary">
            Status
          </Typography>
          <Stack direction="row" alignItems="center" gap={1}>
            <Box
              borderRadius="50%"
              width={8}
              height={8}
              border="1px solid"
              borderColor={status === 'active' ? 'success.light' : 'error.light'}
              bgcolor={status === 'active' ? 'success.light' : 'error.light'}
            />
            <Typography variant="body2" fontWeight={700} textTransform="capitalize">
              {status}
            </Typography>
          </Stack>
        </Stack>
      )}

      {show_files && (
        <Stack justifyContent="center" flex={1}>
          <Link
            component={RouterLink}
            to={`${paths.frameworkAgreementSuppliersFiles(dps_id, dc_id)}`}
            underline="none"
            color="inherit"
          >
            <Typography variant="caption" fontWeight={700} color="text.secondary">
              Files
            </Typography>

            <Typography variant="body2" fontWeight={700}>
              {filesCount}
            </Typography>
          </Link>
        </Stack>
      )}
      <Box flex={1} position="relative">
        <Stack justifyContent="center" height={1}>
          <Typography variant="caption" fontWeight={700} color="text.secondary">
            VAT Number
          </Typography>

          <Typography variant="body2" fontWeight={700}>
            {vatNumber}
          </Typography>
        </Stack>

        {account.super_admin && (
          <SpeedDial
            direction="left"
            ariaLabel="Buyer actions"
            icon={
              <IconWrapper
                icon="elipsisVertical"
                sx={({ palette }) => ({
                  svg: { stroke: palette.grey[500], color: palette.grey[500] },
                })}
              />
            }
            sx={({ palette }) => ({
              '.MuiSpeedDial-actions': { bgcolor: "white", borderRadius: 4, pr:0, mr: 0, border: `1px solid ${palette.grey[200]}` },
              '.MuiSpeedDial-actionsClosed': { bgcolor: 'transparent', border: 'none' },
              '& > button': {
                boxShadow: 'none',
                bgcolor: palette.background.paper,
                width: 36,
                height: 36,
              },
              '& > button:hover': { bgcolor: palette.background.paper },
              position: 'absolute',
              right: -14,
              top: 'calc(50% - 28px)',
              zIndex: 1,
            })}
          >
            <SpeedDialAction
              tooltipTitle="Delete"
              onClick={markForDelete}
              sx={({ palette }) => ({
                bgcolor: palette.grey[50],
                '&:hover': { bgcolor: palette.grey[200] },
              })}
              icon={
                <IconWrapper
                  icon="trash"
                  sx={({ palette }) => ({
                    svg: {
                      width: 20,
                      height: 20,
                      stroke: palette.grey[500],
                      color: palette.grey[500],
                    },
                  })}
                />
              }
            />
          </SpeedDial>
        )}
      </Box>
    </ListCard>
  );
};
